import React from "react";
import { useInView } from 'react-intersection-observer';
import { motion } from "motion/react";

const Journey = () => {
    const { ref: firstRef, inView: firstInView } = useInView({ triggerOnce: true });
    const { ref: secondRef, inView: secondInView } = useInView({ triggerOnce: true });
    const { ref: thirdRef, inView: thirdInView } = useInView({ triggerOnce: true });
    const { ref: fourthRef, inView: fourthInView } = useInView({ triggerOnce: true });
  
    return (
      <ul className="font-frankbook text-white bg-purple text-md md:text-lg my-10 p-5 md:p-12 relative">
        <h3 className="text-white font-euro text-2xl text-center mb-4">My Journey</h3>
        <motion.li
          ref={firstRef}
          className="relative pl-8 pb-6 before:content-[''] before:absolute before:left-1.5 before:top-4 before:w-px before:h-full before:bg-orange last:before:hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: firstInView ? 1 : 0, y: firstInView ? 0 : 20 }}
          transition={{ duration: 0.5 }}
        >
          <div className="absolute left-0 top-1 w-3 h-3 bg-orange"></div>
          I take pride in my curiosity and drive to excel academically and creatively, achieving all A and A* GCSE results across a broad range of subjects - from logical disciplines like maths and finance to creative areas such as creative & media.
        </motion.li>
        <motion.li
          ref={secondRef}
          className="relative pl-8 pb-6 before:content-[''] before:absolute before:left-1.5 before:top-4 before:w-px before:h-full before:bg-orange last:before:hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: secondInView ? 1 : 0, y: secondInView ? 0 : 20 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <div className="absolute left-0 top-1 w-3 h-3 bg-orange"></div>
          My love for the arts led me to further education in acting and music technology, where I achieved a Licentiate Degree from Trinity College London through Performance Preparation Academy (PPA) Guildford.
        </motion.li>
        <motion.li
          ref={thirdRef}
          className="relative pl-8 pb-6 before:content-[''] before:absolute before:left-1.5 before:top-4 before:w-px before:h-full before:bg-orange last:before:hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: thirdInView ? 1 : 0, y: thirdInView ? 0 : 20 }}
          transition={{ duration: 0.5, delay: 0.8 }}
        >
          <div className="absolute left-0 top-1 w-3 h-3 bg-orange"></div>
          Music continues to be a significant part of my life. Whether performing as part of a band or producing music, my creative arts background complements my design expertise, offering valuable insights into event promotion and connecting with brand values on a deeper level.
        </motion.li>
        <motion.li
          ref={fourthRef}
          className="relative pl-8 before:content-[''] before:absolute before:left-1.5 before:top-4 before:w-px before:h-full before:bg-orange last:before:hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: fourthInView ? 1 : 0, y: fourthInView ? 0 : 20 }}
          transition={{ duration: 0.5, delay: 1.2 }}
        >
          <div className="absolute left-0 top-1 w-3 h-3 bg-orange"></div>
          By day, I am a dedicated professional Graphic Designer, delivering high-quality work tailored to a variety of clients. Combining creativity with expert knowledge in advertising and marketing, I help brands achieve meaningful results and bring their vision to life.
        </motion.li>
      </ul>
    );
  };

  export default Journey;